import React, { Fragment } from 'react';
import { Typography, Box, Checkbox, FormControlLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTCString, vendors } from '../iab-tcf';

const useStyles = makeStyles(theme => ({
  purposeDesc: {
    margin: theme.spacing(1, 0, 2),
  },
  checkboxOption: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey[100],
  },
  checkboxDescription: {
    margin: 0,
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
  },
}));

/**
 * Customize consent for:
 * - MR cookie categories IDs
 * - IAB purpose / special features
 */
function PurposesFeaturesTab() {
  const classes = useStyles();

  // force react to re-render when TCString is updated (vendor checkboxes)
  const { refreshTCString } = useTCString();

  // lists / state managed by tcf and not react
  const purposes = vendors.getPurposes();
  const specialFeatures = vendors.getSpecialFeatures();

  const togglePurpose = purposeId => {
    let currentConsent = vendors.getPurposeConsent(purposeId);
    vendors.setPurposeConsent(purposeId, !currentConsent);
    refreshTCString();
  };

  const toggleSpecialFeature = specialFeatureId => {
    let currentConsent = vendors.getSpecialFeaturesConsent(specialFeatureId);
    vendors.setSpecialFeaturesConsent(specialFeatureId, !currentConsent);
    refreshTCString();
  };

  return (
    <Fragment>
      <Box mb={4}>
        <Typography variant="h6" component="h3">
          Purposes
        </Typography>
        <Typography variant="body2" className={classes.purposeDesc}>
          Opting in to a purpose will enable it for any vendor that has declared it as either a purpose or a legitimate
          interest.
        </Typography>

        {purposes.map(purpose => {
          return (
            <Box className={classes.checkboxOption} key={purpose.id}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={vendors.getPurposeConsent(purpose.id)}
                    data-test-id={`checkbox-purpose-${purpose.id}`}
                    onChange={() => togglePurpose(purpose.id)}
                  />
                }
                label={
                  <Typography component="span" variant="body1">
                    {purpose.name}
                  </Typography>
                }
              />
            </Box>
          );
        })}
      </Box>

      <Box>
        <Typography variant="h6" component="h3">
          Special Features
        </Typography>

        {specialFeatures.map(specialFeature => {
          return (
            <Box className={classes.checkboxOption} key={specialFeature.id}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={vendors.getSpecialFeaturesConsent(specialFeature.id)}
                    data-test-id={`checkbox-special-feature-${specialFeature.id}`}
                    onChange={() => toggleSpecialFeature(specialFeature.id)}
                  />
                }
                label={
                  <Typography component="span" variant="body1">
                    {specialFeature.name}
                  </Typography>
                }
              />
            </Box>
          );
        })}
      </Box>
    </Fragment>
  );
}

PurposesFeaturesTab.propTypes = {};

export default PurposesFeaturesTab;
